// extracted by mini-css-extract-plugin
export default {"Title":"Title_Title__IpyQS","headTop":"Title_headTop__s2hRk","interface":"Title_interface__F9V3b","search":"Title_search__7Y2Yh"};